// Get Unmasking Connection
export const GET_UNMASKING_CONNECTION_REQUEST = 'GET_UNMASKING_CONNECTION_REQUEST';
export const GET_UNMASKING_CONNECTION_DONE = 'GET_UNMASKING_CONNECTION_DONE';
export const GET_UNMASKING_CONNECTION_FAILED = 'GET_UNMASKING_CONNECTION_FAILED';
